<div class="item-grid-container">
  <mat-card class="shadow">
    <div class="carrier-promotions-form">
      <form
        [formGroup]="carrierPromoForm"
        (ngSubmit)="onCarrierFormSubmit($event)"
      >
        <div class="form-inner buss-info-details content-details-blk">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="row">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0" translate>
                    {{'pages.PromotionCarrierPromotions.PromotionName' | translate }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="text"
                        [readonly]="readonly"
                        formControlName="editedPromotionName"
                        placeholder="{{'pages.PromotionCarrierPromotions.PromotionName' | translate }}"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0">
                    {{'pages.PromotionCarrierPromotions.promotionHeaderEn' | translate }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="text"
                        formControlName="promotionHeaderEnglish"
                        placeholder="{{'pages.PromotionCarrierPromotions.promotionHeaderEn' | translate }}"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div
                  class="
                    col-lg-3 col-md-3 col-sm-3 col-xs-12
                    align-self-start
                    mt-2
                  "
                >
                  <h4 class="form-item-label mb-0">
                    {{'pages.PromotionCarrierPromotions.PromotionDescriptionEn' | translate }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input textarea">
                    <mat-form-field appearance="outline" class="w-100">
                      <textarea
                        matInput
                        type="text"
                        [readonly]="readonly"
                        formControlName="editedPromotionDescription"
                        placeholder="{{'pages.PromotionCarrierPromotions.PromotionDescriptionEn' | translate }}"
                      ></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                <h4 class="form-item-label mb-0">
                  {{'pages.PromotionCarrierPromotions.promotionHeaderSp' | translate }}
                </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="text"
                        formControlName="promotionHeaderSpanish"
                        placeholder="{{'pages.PromotionCarrierPromotions.promotionHeaderSp' | translate }}"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="
                    col-lg-3 col-md-3 col-sm-3 col-xs-12
                    align-self-start
                    mt-2
                  "
                >
                  <h4 class="form-item-label mb-0">
                    {{'pages.PromotionCarrierPromotions.PromotionDescriptionSp' | translate }}
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input textarea">
                    <mat-form-field appearance="outline" class="w-100">
                      <textarea
                        matInput
                        type="text"
                        formControlName="spanishDescription"
                        placeholder="{{'pages.PromotionCarrierPromotions.PromotionDescriptionSp' | translate }}"
                      ></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0" translate>
                    {{'pages.placeholders.PromotionNameText' | translate }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="text"
                        [readonly]="readonly"
                        formControlName="editedPromotionNameTxtMsg"
                        placeholder="{{'pages.placeholders.NewPromotionName' | translate }}"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0" translate>
                    {{'pages.placeholders.PromotionDescriptionText' | translate }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <textarea
                        matInput
                        type="text"
                        [readonly]="readonly"
                        formControlName="editedPromotionDescTxtMsg"
                        placeholder="{{'pages.placeholders.NewPromotionDescription' | translate }}"
                      ></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0" translate>
                    {{'pages.placeholders.PromotionNameApp' | translate }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="text"
                        [readonly]="readonly"
                        formControlName="editedPromotionNameApp"
                        placeholder="{{'pages.placeholders.NewPromotionName' | translate }}"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0" translate>
                    {{'pages.placeholders.PromotionDescriptionApp' | translate }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <textarea
                        matInput
                        type="text"
                        [readonly]="readonly"
                        formControlName="editedPromotionDescApp"
                        placeholder="{{'pages.placeholders.NewPromotionDescription' | translate }}"
                      ></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0" translate>
                    {{'pages.placeholders.AdditionalInformation' | translate }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <textarea
                        matInput
                        type="text"
                        [readonly]="readonly"
                        formControlName="additionalInfo"
                        placeholder="{{'pages.placeholders.AdditionalInformation' | translate }}"
                      ></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0" translate>{{'pages.Promocodehistory.Validity' | translate }}</h4>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="row">
                <div class="col-12 col-xs-12 col-sm-6">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        [matDatepicker]="picker"
                        [disabled]="readonly"
                        formControlName="promotionStartdttm"
                        placeholder="{{'pages.Creditlinereport.From' | translate }}"
                      />
                      <!-- <span matPrefix>{{'pages.Creditlinereport.From' | translate }}</span> -->
                      <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon
                          >keyboard_arrow_down</mat-icon
                        >
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        [matDatepicker]="picker1"
                        [disabled]="readonly"
                        formControlName="promotionEnddttm"
                        [min]="
                          carrierPromoForm.controls['promotionStartdttm'].value
                        "
                        placeholder="{{'pages.Creditlinereport.To' | translate }}"
                      />
                      <mat-datepicker-toggle matSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon
                          >keyboard_arrow_down</mat-icon
                        >
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0" translate>pages.RewardsConfiguration.Amount</h4>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="row">
                <div class="col-12 col-xs-12 col-sm-6">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        [textMask]="{ mask: numberMask, guide: false }"
                        [readonly]="readonly"
                        formControlName="applicableMinAmount"
                        placeholder="{{'pages.placeholders.Min' | translate }}"
                      />
                      <!--<span matPrefix>$</span>-->
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        [textMask]="{ mask: numberMask, guide: false }"
                        formControlName="applicableMaxAmount"
                        [readonly]="readonly"
                        placeholder="{{'pages.placeholders.Max' | translate }}"
                      />
                      <!--<span matPrefix>$</span>-->
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0">{{'pages.placeholders.MinTopUpAmount' | translate }}</h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    formControlName="minTopUpAmount"
                    [readonly]="readonly"
                    [textMask]="{ mask: numberMask, guide: false }"
                    placeholder="{{'pages.placeholders.MinTopUpAmount' | translate }}"
                  />
                  <!--<span matPrefix>$</span> -->
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0" translate>{{'pages.placeholders.VendorName' | translate }}</h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    formControlName="vendorName"
                    [readonly]="readonly"
                    placeholder="{{'pages.placeholders.VendorName' | translate }}"
                  />
                  <!-- <span matPrefix>$</span> -->
                </mat-form-field>
              </div>
            </div>
          </div>
          <h5 class="content-label-each mt-4 mb-4" translate>
            {{'pages.placeholders.MapPromotionToTilaProduct' | translate }}
          </h5>
          <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0" translate>
                {{'pages.Promocodehistory.CodeGroup' | translate }}<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    formControlName="tilaCodeGroup"
                    [disabled]="readonly"
                    placeholder="{{'pages.placeholders.SelectCodeGroup' | translate }}"
                    (selectionChange)="getCountries($event)"
                  >
                    <mat-option
                      *ngFor="let codeGroup of codeGroups"
                      [value]="codeGroup"
                    >
                      {{ codeGroup }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0" translate>
                {{'pages.Promocodehistory.Country' | translate }}<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    formControlName="tilaCountry"
                    [disabled]="readonly"
                    placeholder="{{'pages.placeholders.SelectCountry' | translate }}"
                    (selectionChange)="getCarriersList($event)"
                  >
                    <mat-option
                      *ngFor="let country of serviceCountries"
                      [value]="country"
                    >
                      {{ country }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0" translate>
                {{'pages.Promocodehistory.Carrier' | translate }}<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    formControlName="tilaCarrier"
                    [disabled]="readonly"
                    placeholder="{{'pages.placeholders.Selectcarrier' | translate }}"
                    (selectionChange)="getsku($event)"
                  >
                    <mat-option
                      *ngFor="let promotionsCarrier of promotionsCarriers"
                      [value]="promotionsCarrier"
                    >
                      {{ promotionsCarrier }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0" translate>
                {{'pages.ManageProducts.Productname' | translate }}<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <!-- {{ skulist |json  }} -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    formControlName="tilaProductId"
                    [disabled]="readonly"
                    placeholder="{{'pages.placeholders.SelectProduct' | translate }}"
                  >
                    <mat-option
                      *ngFor="let sku of skulist"
                      [value]="sku?.productId"
                    >
                      {{ sku?.productName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="row">
              <div class="col-12">
                <mat-checkbox
                  color="primary"
                  formControlName="isCertified"
                  (change)="onCheckCertify($event)"
                  [disabled]="readonly" 
                  class="is-certified"
                  >{{'pages.placeholders.CertifyPromotion' | translate }}</mat-checkbox
                >
              </div>
            </div>
          </div>
          <div class="form-footer text-center">
            <button
              mat-raised-button
              color="primary"
              [disabled]="carrierPromoForm.invalid"
              type="submit"
            >
              {{'pages.placeholders.SavePromotion' | translate }}
            </button>
            <button
              mat-stroked-button
              color="primary"
              type="button"
              
              (click)="onCancel()"
            >
              <span translate class="translate">pages.newRetailer.cancel</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </mat-card>
</div>
